const dropdown = {
    init() {
        dropdown.create();
    },
    create() {
        const dropdownEle = $("[data-dropdown-element]");
        if (!dropdownEle.length) return;

        dropdownEle.on('click', function(event) {
            
            var _time = 0;
            var _this = $(this);
            var dropdownContent = _this.parents('[data-dropdown]').find('[data-dropdown-content]');

            if(_this.parent().hasClass('on')) {
                if(!_this.parent().hasClass('w-service--02')) {
                    event.preventDefault();
                    _this.parent().removeClass('on');
                    dropdownContent.stop().slideUp(350);
                }
            } else {
                event.preventDefault();
                var dropdownCurrent = _this.parents('[data-dropdown-group]').find('[data-dropdown].on');

                if(dropdownCurrent.length > 0) {
                    _time = 350;
                    dropdownCurrent.removeClass('on');
                    dropdownCurrent.find('[data-dropdown-content]').stop().slideUp(350);
                }

                setTimeout(function() {
                    _this.parent().toggleClass('on');
                    dropdownContent.stop().slideToggle(350);
                }, _time)
            }
            
        });
    }
};

$(function() {
    dropdown.init();
});